const keys = [
  "`","1","2","3","4","5","6","7","8","9","0","-","=",
  "Backspace","Tab","q","w","e","r","t","y","u","i","o","p",
  "[","]","\\","CapsLock","a","s","d","f","g","h","j","k","l",
  ";","'","Enter","Shift","z","x","c","v","b","n","m",
  ",",".","/","Shift","Control","Alt","Meta"," ",
  "Meta","Alt","ArrowLeft","ArrowUp","ArrowDown","ArrowRight",
];

export default keys;